import React from "react";

type TShowWhenProps = {
  condition: boolean | undefined;
  children: React.ReactNode;
  elseRender?: React.ReactNode;
};

const ShowWhen: React.FC<TShowWhenProps> = ({
  condition,
  children,
  elseRender = null,
}) => {
  return <>{condition ? children : elseRender}</>;
};

export { ShowWhen };
